import { FC, useState } from "react";
import Modal, { ModalProps } from "@/components/modal";
import { Category } from "@/types/category";
import SelectProduct from "./SelectProduct";
import SelectCategory from "./SelectCategory";
import { Product } from "@/types/product";
import SearchProductByName from "./SearchProductByName";
import styles from "./index.module.scss";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { addProduct } from "@/store/cart/thunk";

const SearchProductModal: FC<Omit<ModalProps, "children">> = (props) => {
  const dispatch = useAppDispatch();
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [filteredProducts, setFilteredProducts] = useState<Product[] | null>(null);

  const onModalClose = () => {
    setFilteredProducts(null);
    setSelectedCategory(null);
    props.onClose();
  };

  const onProductPress = (product: Product) => {
    dispatch(addProduct(product.id));
    onModalClose();
  };

  return (
    <Modal
      {...props}
      onClose={onModalClose}
      modalClassName={styles.modal}
      contentClassName={styles.modalContent}>
      <SearchProductByName setFilteredProducts={setFilteredProducts} />
      {!!selectedCategory || filteredProducts ? (
        <SelectProduct
          category={selectedCategory}
          filteredProducts={filteredProducts}
          onGoBack={() => setSelectedCategory(null)}
          onProductPress={onProductPress}
        />
      ) : (
        <SelectCategory onCategorySelected={setSelectedCategory} />
      )}
    </Modal>
  );
};

export default SearchProductModal;
